import { trpc } from '@/shared/api';
import {
  type PaymentProviderFilter,
  type PaymentStatusFilter,
  statusesForFilter,
} from '../model/status-filter';

const PAYMENTS_PAGE_SIZE = 20;

interface PaymentsListParams {
  readonly page: number;
  readonly statusFilter: PaymentStatusFilter;
  readonly providerFilter?: PaymentProviderFilter;
}

/** 어드민 결제 목록(paymentManagement.list) — 기본 필터는 입력에서 빼서 서버 기본값을 쓴다. */
export const usePaymentsListQuery = ({
  page,
  statusFilter,
  providerFilter = 'ALL',
}: PaymentsListParams) => {
  const statuses = statusesForFilter(statusFilter);

  return trpc.paymentManagement.list.useQuery({
    page,
    limit: PAYMENTS_PAGE_SIZE,
    ...(statuses ? { statuses } : {}),
    ...(providerFilter === 'ALL' ? {} : { provider: providerFilter }),
  });
};
